import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2, Trash2 } from "lucide-react";
import { adminApi } from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const resolveImage = (src) => (src && src.startsWith("/api/") ? `${BACKEND}${src}` : src);

export const ImageUpload = ({ value, onChange, testid = "image-upload" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const res = await adminApi.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(res.data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed");
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div>
      <span className="text-[11px] font-bold uppercase tracking-wider text-slate-400">Image</span>
      <div className="mt-1 flex gap-3 items-start">
        <div className="w-24 h-24 rounded-xl overflow-hidden bg-slate-100 dark:bg-emerald-900 border border-slate-200 dark:border-emerald-800 shrink-0 flex items-center justify-center">
          {value ? <img src={resolveImage(value)} alt="preview" className="w-full h-full object-cover" /> : <span className="text-[10px] text-slate-400">No image</span>}
        </div>
        <div className="flex-1 space-y-2">
          <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={pick} data-testid={`${testid}-file`} />
          <button type="button" data-testid={`${testid}-btn`} onClick={() => ref.current?.click()} disabled={busy}
            className="w-full flex items-center justify-center gap-2 text-xs font-bold bg-emerald-50 dark:bg-emerald-800 text-emerald-700 dark:text-emerald-200 py-2.5 rounded-xl disabled:opacity-60">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} Upload from device
          </button>
          <input data-testid={`${testid}-url`} value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="…or paste image URL"
            className="w-full px-3 py-2 rounded-xl bg-white dark:bg-emerald-900/60 border border-slate-200 dark:border-emerald-800 text-xs text-slate-800 dark:text-slate-100 focus:outline-none" />
          {value && (
            <button type="button" onClick={() => onChange("")} className="flex items-center gap-1 text-[11px] text-rose-500"><Trash2 className="w-3 h-3" /> Remove image</button>
          )}
        </div>
      </div>
    </div>
  );
};
